import React, { useState } from "react";
import { Maximize2 } from "lucide-react";
import AutomatedEmailPreview from "@/components/settings/AutomatedEmailPreview";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import type { AutomatedEmailTemplateKey } from "@/services/organizationSettings";

interface EmailTemplatePreviewDialogProps {
  templateKey: AutomatedEmailTemplateKey;
  title: string;
  subject: string;
  body: string;
}

/** Full-size modal preview, opened from the inline preview's subject bar. */
const EmailTemplatePreviewDialog: React.FC<EmailTemplatePreviewDialogProps> = ({
  templateKey,
  title,
  subject,
  body,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="h-7 w-7"
          aria-label="Open full-size preview"
          title="Open full-size preview"
        >
          <Maximize2 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="flex max-h-[92vh] w-[min(72rem,calc(100vw-2rem))] max-w-none flex-col">
        <DialogHeader>
          <DialogTitle>{title} preview</DialogTitle>
          <DialogDescription>
            Rendered with sample deal data. Unsaved changes are included.
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 overflow-y-auto pr-1">
          {open && (
            <AutomatedEmailPreview
              templateKey={templateKey}
              subject={subject}
              body={body}
              className="h-[min(40rem,75vh)]"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EmailTemplatePreviewDialog;
